import { render, staticRenderFns } from "./StatsSuperAdmin.vue?vue&type=template&id=569ea13a&"
import script from "./StatsSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./StatsSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports